// import { useEffect, useState } from "react";
// import { db } from "../firebase";
// import { ref, set, onValue, onDisconnect } from "firebase/database";

// function getVisitorId() {
//   let id = localStorage.getItem("visitorId");

//   if (!id) {
//     id =
//       "visitor_" +
//       Math.random().toString(36).slice(2) +
//       "_" +
//       Date.now().toString(36);

//     localStorage.setItem("visitorId", id);
//   }

//   return id;
// }

// export default function useOnlineUsers() {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     const visitorId = getVisitorId();
//     const userRef = ref(db, `online-users/${visitorId}`);
//     const usersRef = ref(db, "online-users");
//     const connectedRef = ref(db, ".info/connected");

//     // gérer onglets
//     let tabCount = Number(localStorage.getItem("tabCount") || "0");
//     localStorage.setItem("tabCount", tabCount + 1);

//     const handleDisconnect = () => {
//       const current = Number(localStorage.getItem("tabCount") || "1") - 1;

//       if (current <= 0) {
//         localStorage.removeItem("tabCount");
//         set(userRef, null); // supprimer user
//       } else {
//         localStorage.setItem("tabCount", current);
//       }
//     };

//     window.addEventListener("beforeunload", handleDisconnect);

//     // connexion Firebase
//     onValue(connectedRef, (snap) => {
//       if (snap.val() === true) {
//         set(userRef, {
//           online: true,
//           lastSeen: Date.now(),
//         });

//         onDisconnect(userRef).remove();
//       }
//     });

//     // écoute
//     onValue(usersRef, (snapshot) => {
//       const data = snapshot.val();
//       setCount(data ? Object.keys(data).length : 0);
//     });

//     return () => {
//       window.removeEventListener("beforeunload", handleDisconnect);
//     };
//   }, []);

//   return count;
// }
import { useEffect, useState } from "react";

function getVisitorId() {
  let id = localStorage.getItem("visitorId");

  if (!id) {
    id =
      "visitor_" +
      Math.random().toString(36).slice(2) +
      "_" +
      Date.now().toString(36);

    localStorage.setItem("visitorId", id);
  }

  return id;
}

export default function useOnlineUsers() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (window.__PRERENDER__) return;

    let unsubscribeConnected;
    let unsubscribeUsers;

    const timer = setTimeout(async () => {
      const { db } = await import("../firebase");
      const { ref, set, onValue, onDisconnect } =
        await import("firebase/database");

      const visitorId = getVisitorId();

      const userRef = ref(db, `online-users/${visitorId}`);
      const usersRef = ref(db, "online-users");
      const connectedRef = ref(db, ".info/connected");

      unsubscribeConnected = onValue(connectedRef, (snap) => {
        if (snap.val() === true) {
          set(userRef, {
            online: true,
            lastSeen: Date.now(),
          });

          onDisconnect(userRef).remove();
        }
      });

      unsubscribeUsers = onValue(usersRef, (snapshot) => {
        const data = snapshot.val();
        setCount(data ? Object.keys(data).length : 0);
      });
    }, 3000);

    return () => {
      clearTimeout(timer);
      if (unsubscribeConnected) unsubscribeConnected();
      if (unsubscribeUsers) unsubscribeUsers();
    };
  }, []);

  return count;
}
